// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2txPD","bigColWidth":"Table_bigColWidth__1xrUe","biggerColWidth":"Table_biggerColWidth__34dCC","row":"Table_row__2CD9i","col":"Table_col__U-1Sl"};